"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";
import { STATS, type Stat } from "../data/stats";

// A single number that counts up from zero once it scrolls into view.
const CountUp = t0 => {
  const $ = _c(14);
  const {
    stat
  } = t0;
  const reduce = useReducedMotion();
  const ref = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      once: true,
      margin: "-60px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const inView = useInView(ref, t1);
  const [display, setDisplay] = useState(reduce ? stat.value : 0);
  let t2;
  let t3;
  if ($[1] !== inView || $[2] !== reduce || $[3] !== stat.value) {
    t2 = () => {
      if (!inView || reduce) {
        return;
      }
      const controls = animate(0, stat.value, {
        duration: 1.4,
        ease: "easeOut",
        onUpdate: v => setDisplay(Math.round(v))
      });
      return () => controls.stop();
    };
    t3 = [inView, reduce, stat.value];
    $[1] = inView;
    $[2] = reduce;
    $[3] = stat.value;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== display || $[7] !== stat.suffix) {
    t4 = <p ref={ref} className="text-4xl font-extrabold tracking-tight text-primary sm:text-5xl">{display}{stat.suffix}</p>;
    $[6] = display;
    $[7] = stat.suffix;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== stat.label) {
    t5 = <p className="mt-2 text-sm text-muted-foreground">{stat.label}</p>;
    $[9] = stat.label;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="text-center">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export const StatsCounter = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="relative py-16 sm:py-20"><div className="mx-auto grid w-full max-w-5xl grid-cols-2 gap-8 px-4 sm:px-6 lg:grid-cols-4 lg:px-8">{STATS.map(_temp)}</div></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(stat) {
  return <CountUp key={stat.label} stat={stat} />;
}